import { format, parseISO } from 'date-fns';

export const formatDate = (dateString) => {
  return format(parseISO(dateString), 'dd/MM/yyyy');
};

export const formatData = (data) => {
  const formattedData = data.map((item) => {
    return {
      ...item,
      date: formatDate(item.date),
    };
  });

  return formattedData;
};